import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import { CartProvider } from "@/context/CartContext";
import { AuthProvider } from "@/context/AuthContext";
import Layout from "@/components/layout/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Videos from "@/pages/Videos";
import Shop from "@/pages/Shop";
import ProductDetail from "@/pages/ProductDetail";
import Checkout from "@/pages/Checkout";
import OrderConfirmed from "@/pages/OrderConfirmed";
import PaymentCancelled from "@/pages/PaymentCancelled";
import VerificationPage from "@/pages/VerificationPage";
import Contact from "@/pages/Contact";
import Donate from "@/pages/Donate";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";

const Site = ({ children }) => <Layout>{children}</Layout>;

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <AuthProvider>
          <CartProvider>
            <BrowserRouter>
              <Routes>
                <Route path="/" element={<Site><Home /></Site>} />
                <Route path="/a-propos" element={<Site><About /></Site>} />
                <Route path="/videos" element={<Site><Videos /></Site>} />
                <Route path="/boutique" element={<Site><Shop /></Site>} />
                <Route path="/boutique/:id" element={<Site><ProductDetail /></Site>} />
                <Route path="/checkout" element={<Site><Checkout /></Site>} />
                <Route path="/commande-confirmee" element={<Site><OrderConfirmed /></Site>} />
                <Route path="/paiement-annule" element={<Site><PaymentCancelled /></Site>} />
                <Route path="/verification/:digitalId" element={<Site><VerificationPage /></Site>} />
                <Route path="/contact" element={<Site><Contact /></Site>} />
                <Route path="/faire-un-don" element={<Site><Donate /></Site>} />
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route path="/admin" element={<AdminDashboard />} />
              </Routes>
            </BrowserRouter>
            <Toaster position="top-center" richColors />
          </CartProvider>
        </AuthProvider>
      </HelmetProvider>
    </div>
  );
}

export default App;
